<script setup>
import { useI18n } from 'vue-i18n';
import InboxReconnectionRequired from '../components/InboxReconnectionRequired.vue';

const emit = defineEmits(['reauthorize']);

const { t } = useI18n();
</script>

<template>
  <InboxReconnectionRequired
    class="mx-6"
    :action-label="
      t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.AUTHORIZATION.GO_TO_CONFIGURATION')
    "
    :description="
      t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.AUTHORIZATION.REAUTH_BANNER')
    "
    @reauthorize="emit('reauthorize')"
  />
</template>
